import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

interface Branding {
  name: string;
  app_name: string;
  tagline: string;
  support: {
    email: string;
  };
}

interface BrandingContextType {
  branding: Branding;
}

const branding: Branding = {
  name: 'Wedsy',
  app_name: 'Wedsy',
  tagline: 'Beautiful invites, effortlessly',
  support: { email: 'hello@wedsy.co' },
};

const BrandingContext = createContext<BrandingContextType>({ branding });

export function BrandingProvider({ children }: { children: ReactNode }) {
  return (
    <BrandingContext.Provider value={{ branding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
